import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=3d5e0bfe&"
import script from "./app-header.vue?vue&type=script&lang=ts&"
export * from "./app-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports